import React from "react";

export default function CreateBlogHeader() {
  return (
    <div className="mb-6">
      <h1 className="font-extrabold text-3xl sm:text-4xl text-slate-900 mb-2">
        Create New <span className="text-[#7209B7]">Blog</span>
      </h1>
      <p className="text-slate-500 text-sm sm:text-base">
        Share your travel stories and inspire fellow travelers.
      </p>
    </div>
  );
}
